import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { TeamSelectionOutput } from "types/web-app";

export const getTeamSelection = async (accessToken: string) => {
  const response = await fetchWithAuth("/team-selection", accessToken);
  const data = (await response.json()) as ServiceResponse<TeamSelectionOutput>;
  return data;
};

